import PlayerContainer from './playerContainer';
export default PlayerContainer;